var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_65_8999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.3335 5.33337V3.46671C5.3335 2.71997 5.3335 2.3466 5.47882 2.06139C5.60665 1.8105 5.81063 1.60653 6.06151 1.4787C6.34672 1.33337 6.72009 1.33337 7.46683 1.33337H12.5335C13.2802 1.33337 13.6536 1.33337 13.9388 1.4787C14.1897 1.60653 14.3937 1.8105 14.5215 2.06139C14.6668 2.3466 14.6668 2.71997 14.6668 3.46671V8.53337C14.6668 9.28011 14.6668 9.65348 14.5215 9.93869C14.3937 10.1896 14.1897 10.3936 13.9388 10.5214C13.6536 10.6667 13.2802 10.6667 12.5335 10.6667H10.6668",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.3335 7.46671C1.3335 6.71997 1.3335 6.3466 1.47882 6.06139C1.60665 5.8105 1.81063 5.60653 2.06151 5.4787C2.34672 5.33337 2.72009 5.33337 3.46683 5.33337H8.5335C9.28023 5.33337 9.6536 5.33337 9.93882 5.4787C10.1897 5.60653 10.3937 5.8105 10.5215 6.06139C10.6668 6.3466 10.6668 6.71997 10.6668 7.46671V12.5334C10.6668 13.2801 10.6668 13.6535 10.5215 13.9387C10.3937 14.1896 10.1897 14.3936 9.93882 14.5214C9.6536 14.6667 9.28023 14.6667 8.5335 14.6667H3.46683C2.72009 14.6667 2.34672 14.6667 2.06151 14.5214C1.81063 14.3936 1.60665 14.1896 1.47882 13.9387C1.3335 13.6535 1.3335 13.2801 1.3335 12.5334V7.46671Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_65_8999"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/IconCopy.f6d38146886200867edcc9e7fdd5be3a.svg";
export { ForwardRef as ReactComponent };